<template>
	<!-- Order Manager Card -->
	<a-card :bordered="false" class="dashboard-bar-chart">
		<chart-bar :height="220" :data="barChartData"></chart-bar>
		<div class="card-title">
			<h6>Total Orders</h6> <span class="text-success">{{ totalOrders }}</span>
		</div>
		<div class="card-content">
		</div>
		<a-row class="card-footer" type="flex" justify="center" align="top">
			<a-col :span="6">
			    <h4>{{ inprogress }}</h4>
				<span>Inprogress</span>
			</a-col>
			<a-col :span="6">
				<h4>{{ pending }}</h4>
				<span>Pending</span>
			</a-col>
			<a-col :span="6">
				<h4>{{  scheduled }}</h4>
				<span>Scheduled</span>
			</a-col>
			<a-col :span="6">
				<h4>{{ ready }}</h4>
				<span>Ready</span>
			</a-col>
		</a-row>
	</a-card>
	<!-- Order Manager Card -->

</template>

<script>

	// Bar chart for "Active Users" card.
	import ChartBar from '../chartbars/ChartBar.vue' ;

	export default ({
		props : {
			inprogress : Number,
			pending : Number,
			scheduled : Number,
			ready : Number,
			totalOrders : Number,
			dataLabels : Array,
			dataOrders : Array,
		},
		components: {
			ChartBar,
		},
		data() {
			return {
				// Data for bar chart.
				barChartData: {
					labels: this.dataLabels,
					datasets: [{
						label: "Sales",
						backgroundColor: '#fff',
						borderWidth: 0,
						borderSkipped: false,
						borderRadius: 6,
						data: this.dataOrders,
						maxBarThickness: 20,
					}, ],
				},
			}
		},
		// watch : {
        // 	dataOrders : {
        //     	handler(newValue) {
		// 			console.log('watcher is called')
		// 			console.log(newValue)
        //         	this.dataOrders = newValue;
        //     	},
        //     	flush : 'post',
		// 		deep : true
        // 	}
    	// }
	})

</script>